import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import userActions from "./actions";
import { Grid } from "@material-ui/core";
import PreviewTile from "components/common/PreviewTile";
import Header from "./Header";

const UsersOverview = () => {
  const { breakDown } = useSelector((state) => state.user);
  const { loadBreakDown } = userActions();

  useEffect(() => {
    loadBreakDown();
  }, [loadBreakDown]);

  return (
    <>
      <Header>Members</Header>
      <Grid container justify="flex-start">
        {[
          {
            h: "Members",
            c: breakDown && breakDown.members,
          },
          {
            h: "Super User",
            c: breakDown && breakDown.super_users,
          },
          {
            h: "Pending Verification",
            c: breakDown && breakDown.pending_approval,
          },
        ].map((value) => (
          <PreviewTile title={value.h} text={String(value.c)} key={value.h} />
        ))}
      </Grid>
    </>
  );
};

export default UsersOverview;
